<div class="header-bar">
  <h1>Checklist Steps</h1>
</div>

<div class="content-container">
  <div class="filterPanel">
    <div class="flex grid-gap-15">
      <div class="flex-grow-1">
        <p-dropdown
          [(ngModel)]="filterStepType"
          (onChange)="applyFilters()"
          [options]="stepTypeOptions"
        ></p-dropdown>
      </div>
      <div class="flex-grow-1">
        <p-dropdown
          [(ngModel)]="filterTaskType"
          (onChange)="applyFilters()"
          [options]="taskTypeOptions"
        ></p-dropdown>
      </div>
      <div class="flex-grow-1">
        <p-dropdown
          [(ngModel)]="filterIsCurrent"
          (onChange)="applyFilters()"
          [options]="isCurrentOptions"
        ></p-dropdown>
      </div>
      <div class="flex-grow-1">
        <p-dropdown
          [(ngModel)]="filterIsPickup"
          (onChange)="applyFilters()"
          [options]="isPickupOptions"
        ></p-dropdown>
      </div>
    </div>
  </div>

  <p-table [value]="filteredSteps" [rows]="20" [paginator]="true" [autoLayout]="true">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="id">Id</th>
        <th pSortableColumn="name" class="text-left" style="padding-left: 13px">Name</th>
        <th pSortableColumn="order">Order</th>
        <th class="text-left" style="padding-left: 13px">StepType</th>
        <th class="text-left" style="padding-left: 13px">TaskType</th>
        <th>Active</th>
        <th>P/D</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr>
        <td class="text-center">{{ item.id }}</td>
        <td>{{ item.name }}</td>
        <td class="text-center">{{ item.order }}</td>
        <td class="text-left">{{ stepTypeName[item.stepType] }}</td>
        <td class="text-left">{{ item.taskType?.name }} {{ item.taskTypeId }}</td>
        <td class="text-center cursor-pointer" (click)="toggleCurrent(item)">
          <span class="text-success" *ngIf="item.isCurrent"><i class="fa fa-check"></i></span>
          <span class="text-danger" *ngIf="!item.isCurrent"><i class="fa fa-times"></i></span>
        </td>
        <td class="text-center">{{ item.isPickUp ? 'Pick-Up' : 'Drop-Off' }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '475px' }"
  acceptLabel="Confirm"
  rejectLabel="Cancel"
></p-confirmDialog>
